function extractAnchorFromLiveWindow(liveWindow) {
    if (liveWindow === null || liveWindow === void 0 ? void 0 : liveWindow.anchor) {
        return liveWindow.anchor;
    } else if (liveWindow === null || liveWindow === void 0 ? void 0 : liveWindow.startDate) {
        return {
            relativeTime: liveWindow.start,
            date: liveWindow.startDate
        };
    }
}
export function contentTimeToAbsoluteDate(contentTimeSec, liveWindow) {
    var anchor = extractAnchorFromLiveWindow(liveWindow);
    if (!anchor) {
        return;
    }
    var offsetMs = Math.ceil((contentTimeSec - anchor.relativeTime) * 1000);
    return new Date(anchor.date.getTime() + offsetMs);
}
export function absoluteDateToContentTime(absDate, liveWindow) {
    var anchor = extractAnchorFromLiveWindow(liveWindow);
    if (!anchor) {
        return;
    }
    var offsetSec = Math.ceil(absDate.getTime() - anchor.date.getTime()) / 1000;
    return anchor.relativeTime + offsetSec;
}

//# sourceMappingURL=live-window-utils.js.map